import usePosOrderCurrentAction from "@/shared/atoms/usePosOrderCurrentAction";
import { useSetModal } from "@/shared/atoms/useModal";
import usePosOrderSelectedCartItemIndex from "@/shared/atoms/usePosOrderSelectedCartItemIndex";
import { useCart, useReplaceCartItem } from "@/shared/hooks/useCartHook";
import useActionClick from "./useActionClick";
import PosMenuBottomActionButton, {
  PosMenuAction,
} from "../PosMenu/PosMenuBottomActionButton";
import { useTranslation } from "react-i18next";
import { CurrentActionTypes } from "@/shared/atoms/usePosOrderCurrentAction";
import { useMemo } from "react";

const useAddToppingAction = (): PosMenuAction => {
  const { t } = useTranslation();
  const [selectedCartItemIndex] = usePosOrderSelectedCartItemIndex();
  const [cart] = useCart();
  const replaceCartItem = useReplaceCartItem();
  const setModal = useSetModal();

  const selectedCartItem = useMemo(
    () => cart[selectedCartItemIndex] ?? {},
    [cart, selectedCartItemIndex],
  );

  const hasSelectedToppings = Boolean(
    selectedCartItem?.selected_sub_content?.length,
  );

  return {
    name: "addTopping" as CurrentActionTypes,
    label: t("posOrders.addTopping"),
    set: () =>
      setModal("posOrderSelectToppings", {
        isEdit: true,
        index: selectedCartItemIndex,
        product: cart[selectedCartItemIndex],
      }),
    deleteAction: () => {
      if (selectedCartItemIndex == null) return;
      replaceCartItem(
        { ...selectedCartItem, selected_sub_content: [] },
        selectedCartItemIndex,
      );
    },
    hasDeleteAction: hasSelectedToppings,
    instantSet: true,
    filtered: false,
    disabled: Boolean(selectedCartItem?.sub_content?.length) === false,
    iconVariant:"objectgroup",
  };
};

const AddToppingAction = () => {
  const [currentAction] = usePosOrderCurrentAction();
  const action = useAddToppingAction();
  const handleClick = useActionClick(action);
  
  return (
    <PosMenuBottomActionButton
      action={action}
      isSelected={currentAction?.name === action.name}
      onClick={handleClick}
    />
  );
};

export default AddToppingAction;
